import React from "react"
import { twMerge } from "tailwind-merge"

export const CardTitle = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => (
  <div className="flex flex-col space-y-1.5">
    <h3
      className={twMerge(
        "text-2xl font-semibold leading-none tracking-tight",
        className
      )}
    >
      {children}
    </h3>
  </div>
)
export const CardContent = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => (
  <div className="p-6 pt-0">
    <p className={twMerge("text-sm", className)}>{children}</p>
  </div>
)

export const CardDescription = ({
  children,
}: {
  children: React.ReactNode
}) => <p className="text-sm text-muted-foreground">{children}</p>

export const CardHeader = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col space-y-1.5 p-6">{children}</div>
)

export const Card = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => (
  <div
    className={twMerge(
      "rounded-lg border text-card-foreground shadow-sm bg-background/60 backdrop-blur h-full",
      className
    )}
  >
    {children}
  </div>
)
